import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";

/**
 * Small info icon that shows its description instantly on hover.
 * The bubble is rendered through a portal to <body> and positioned with fixed coordinates,
 * so it appears immediately (no native ~1s delay) and never gets clipped by scroll containers.
 */
const InfoTip = ({ text }) => {
  const [pos, setPos] = useState(null);
  const iconRef = useRef(null);

  const show = () => {
    const r = iconRef.current?.getBoundingClientRect();
    if (r) setPos({ top: r.bottom + 6, left: r.left + r.width / 2 });
  };
  const hide = () => setPos(null);

  if (!text) return null;

  return (
    <>
      <i
        ref={iconRef}
        className="fas fa-info-circle"
        onMouseEnter={show}
        onMouseLeave={hide}
        aria-label={text}
        style={{ marginLeft: 6, color: "#94a3b8", fontSize: 11.5, cursor: "pointer", verticalAlign: "middle" }}
      />
      {pos &&
        ReactDOM.createPortal(
          <span
            style={{
              position: "fixed",
              top: pos.top,
              left: pos.left,
              transform: "translateX(-50%)",
              maxWidth: 280,
              background: "#ffffff",
              color: "#475569",
              border: "1px solid #e2e8f0",
              fontSize: 12,
              fontWeight: 400,
              lineHeight: 1.5,
              textAlign: "left",
              padding: "10px 12px",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(15,23,42,0.12)",
              zIndex: 99999,
              whiteSpace: "normal",
              textTransform: "none",
              letterSpacing: "normal",
              pointerEvents: "none",
            }}
          >
            {text}
          </span>,
          document.body,
        )}
    </>
  );
};

export default InfoTip;
